import React from 'react'
import ReactDOM from 'react-dom'

import LoadStyles from '@driftt/tide-core/dist/styles'
import ConnectedApp from '@driftt/traffic-control'
import config from 'config'
import {
  rootEpic,
  rootReducer
} from 'modules'

import App from './layouts/App'

import './index.css'

const sentryKey = 'https://fa43393cd17a4803b7242442475ce9b8@sentry.io/1418124'

ReactDOM.render(<ConnectedApp
  reducers={rootReducer}
  epics={rootEpic}
  sentryId={sentryKey}
  render={() => <App />}
  authClientId={config.AUTH_CLIENT_ID}
/>, document.getElementById('root'))

LoadStyles()
